import React from 'react';
import { MailOutline, PhoneOutlined } from '@mui/icons-material';
import { Colors } from 'library';
import { Link, Stack, Text } from 'library/ui';
import { useCenterContact } from 'parent-portal/shared/useCenterContact';

export function ContactInfo() {
    const { email, phoneNumber } = useCenterContact();

    return (
        <Stack gap="sm" padding="sm">
            <Text weight="bold">Need help?</Text>
            <Link href={`mailto:${email}`} underline={false} weight="medium" icon={<MailOutline sx={iconSx} />} wrap>
                {email}
            </Link>
            <Link
                href={`tel:${phoneNumber}`}
                underline={false}
                weight="medium"
                icon={<PhoneOutlined sx={iconSx} />}
                wrap
            >
                {phoneNumber}
            </Link>
        </Stack>
    );
}

const iconSx = { fontSize: 16, color: Colors.primary };
